module.exports = {
      id: "pisces-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#pisces",
      toString: function () {
        return this.url;
      }
    }